<%= form_with(model: age_cost, class: "contents") do |form| %>
  <% if age_cost.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(age_cost.errors.count, "error") %> prohibited this age_cost from being saved:</h2>

      <ul class="list-disc ml-6">
        <% age_cost.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :age_id %>
    <%= form.text_field :age_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": age_cost.errors[:age_id].none?, "border-red-400 focus:outline-red-600": age_cost.errors[:age_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :heat_cost %>
    <%= form.text_field :heat_cost, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": age_cost.errors[:heat_cost].none?, "border-red-400 focus:outline-red-600": age_cost.errors[:heat_cost].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :solo_cost %>
    <%= form.text_field :solo_cost, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": age_cost.errors[:solo_cost].none?, "border-red-400 focus:outline-red-600": age_cost.errors[:solo_cost].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :multi_cost %>
    <%= form.text_field :multi_cost, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": age_cost.errors[:multi_cost].none?, "border-red-400 focus:outline-red-600": age_cost.errors[:multi_cost].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
